"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment PickupPoint on PickupPoint {\n    deliveryChannelId\n    isAllowed\n    shippingFee\n    originalShippingFee\n    isShippingJoker\n    outOfStockQuantity\n    estimatedDeliveryDate\n    deliveryChannel {\n      coordinates {\n        latitude\n        longitude\n      }\n      description\n      deliveryMethod\n      workingHours\n      telephoneNumber\n      address {\n        addressId\n        city\n        streetAddress\n        zipcode\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n  query deliveryChannels(\n    $sessionId: String!\n    $latitude: Float\n    $longitude: Float\n    $radius: Float\n    $searchTerm: String\n    $skip: Int!\n    $top: Int!\n  ) {\n    shopping {\n      shoppingSession(sessionId: $sessionId) {\n        deliveryChannels(\n          latitude: $latitude\n          longitude: $longitude\n          radius: $radius\n          searchTerm: $searchTerm\n          skip: $skip\n          top: $top\n          searchFilter: All\n        ) {\n          collection {\n            ...PickupPoint\n          }\n          totalRecords\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deliveryChannelsQuery = void 0;
var _fetching = require("@ori/fetching");
const pickupPointFragment = (0, _fetching.gql)(_templateObject());
const deliveryChannelsQuery = exports.deliveryChannelsQuery = (0, _fetching.gql)(_templateObject1(), pickupPointFragment);
